// extracted by mini-css-extract-plugin
module.exports = {"list":"ContactComponent_list_1BnSx","label":"ContactComponent_label_PkGpc","expanded":"ContactComponent_expanded_13340"};